import { addColSpan, assertColspan } from './colspan';
import { tableNodeTypes } from './table-node-types';
export function columnIsHeader(map, table, col) {
  var headerCell = tableNodeTypes(table.type.schema).header_cell;
  for (var row = 0; row < map.height; row++) {
    var cell = table.nodeAt(map.map[col + row * map.width]);
    if (cell && cell.type !== headerCell) {
      return false;
    }
  }
  return true;
}

// Add a column at the given position in a table.
export function addColumn(tr, _ref, col) {
  var map = _ref.map,
    tableStart = _ref.tableStart,
    table = _ref.table;
  var refColumn = col > 0 ? -1 : 0;
  if (columnIsHeader(map, table, col + refColumn)) {
    refColumn = col === 0 || col === map.width ? null : 0;
  }
  for (var row = 0; row < map.height; row++) {
    var index = row * map.width + col;

    // If this position falls inside a col-spanning cell
    if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
      var pos = map.map[index];
      var cell = table.nodeAt(pos);
      if (!cell) {
        throw new Error("addColumn: invalid cell for pos ".concat(pos));
      }
      var attributes = cell.attrs;
      assertColspan(attributes);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, addColSpan(attributes, col - map.colCount(pos)));
      // Skip ahead if rowspan > 1
      row += attributes.rowspan - 1;
    } else {
      var type = void 0;
      var attrs = {};
      if (refColumn === null) {
        type = tableNodeTypes(table.type.schema).cell;
      } else {
        var mappedPos = map.map[index + refColumn];
        var _cell = table.nodeAt(mappedPos);
        if (!_cell) {
          throw new Error("addColumn: invalid node at mapped pos ".concat(mappedPos));
        }
        type = _cell.type;
        if (_cell.attrs.background) {
          attrs = {
            background: _cell.attrs.background
          };
        }
      }
      var _pos = map.positionAt(row, col, table);
      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      tr.insert(tr.mapping.map(tableStart + _pos), type.createAndFill(attrs));
    }
  }
  return tr;
}